import { render, staticRenderFns } from "./recommend_item_advertise3.vue?vue&type=template&id=2ae447dd&scoped=true&"
import script from "./recommend_item_advertise3.vue?vue&type=script&lang=ts&"
export * from "./recommend_item_advertise3.vue?vue&type=script&lang=ts&"
import style0 from "./recommend_item_advertise3.vue?vue&type=style&index=0&id=2ae447dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae447dd",
  null
  
)

export default component.exports